import moment from "moment";
import { isMobileNumberValid } from "./CommonFunction";
const HelperService = {
  getFormatedDateByDMY(d: any) {
    if (!d || d === "0000-00-00") return "NA";

    return moment(d).isValid() ? moment(d).format("DD-MMM-YYYY") : "NA";
  },
  getFormatedDateByDMYTime(d: any) {
    return d && d !== "0000-00-00"
      ? moment(d).format("DD-MMM-YYYY hh:mm A")
      : "NA";
  },

  isImageFile(url: string): boolean {
    return /\.(jpeg|jpg|gif|png|webp|bmp|svg)$/i.test(url);
  },
  ProperCase(str: string) {
    if (!str) {
      return "";
    }
    const pattern = /_/gi;
    const replacement = " ";
    const result = str.replaceAll(pattern, replacement);

    return result.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  },
  getFormattedCurrency(amount: any) {
    if (amount === "" || amount === undefined) {
      return "";
    }
    if (amount === 0) {
      return "₹0";
    }

    if (!amount) {
      return "";
    }
    var fractionDigit = 0;
    if (amount % 1 > 0) {
      fractionDigit = 2;
    }
    var inr = Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: localStorage.getItem("currency") ?? "INR",
      minimumFractionDigits: fractionDigit,
    }).format(amount);
    return inr;
  },
  isValidEmail(email: string) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    return regex.test(email);
  },
  isValidPassword(password: string) {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (passwordRegex.test(password)) return true;
    else return false;
  },
  checkWebUrl(url: string) {
    const urlPattern =
      /^(https?:\/\/)?([\w.-]+)\.([a-z]{2,6})(\/[\w.-]*)*\/?$/i;
    return urlPattern.test(url);
  },
  checkLinkedinUrl(url: string) {
    const linkedinPattern =
      /^(https?:\/\/)?(www\.)?linkedin\.com\/(in|company|school)\/[a-zA-Z0-9-_%]+\/?$/i;

    return linkedinPattern.test(url.trim());
  },
  isValidSocialUrl(url: string): boolean {
    const socialUrlPattern =
      /^(https?:\/\/)?(www\.)?(facebook|twitter|instagram|linkedin|youtube|tiktok|github|reddit|pinterest|snapchat|twitch|threads)\.com(\/[\w\-./?%&=]*)?$/i;

    const websiteUrlPattern =
      /^(https?:\/\/)?([\w-]+\.)+[\w]{2,}(\/[\w\-./?%&=]*)?$/i;

    return socialUrlPattern.test(url) || websiteUrlPattern.test(url);
  },

  checkFormEmptyFields(obj: any, excludedKeys: any[] = []) {
    let emptyKeyFlag = false;
    const excludedKeysSet = new Set(excludedKeys);

    Object.keys(obj).forEach((key) => {


      const value = obj[key];

      // ✅ handle Date explicitly
      const isValidDate = value instanceof Date && !isNaN(value.getTime());

      const isEmptyValue =
        value === undefined ||
        value === null ||
        (typeof value === "string" && value.trim() === "") ||
        (typeof value === "object" &&
          !isValidDate && // ❗ exclude Date objects
          !Array.isArray(value) &&
          Object.keys(value).length === 0);

      if (!excludedKeysSet.has(key) && isEmptyValue) {
        console.log("empty_key", key, value);
        emptyKeyFlag = true;
      }

      // 📞 mobile validation
      if (key === "mobile_number") {
        const checkValidMobile = isMobileNumberValid(
          obj["mobile_number"],
          obj["dial_code"],
        );

        if (!checkValidMobile) emptyKeyFlag = true;
      }
    });

    return emptyKeyFlag;
  },

  truncate(str: string, size: number) {
    return str.length > size ? str?.substring(0, size) + "..." : str;
  },
  removeUnderScore(str: any) {
    if (!str || typeof str !== "string") {
      return "";
    }
    if (str.includes("_")) {
      return this.titleCase(str.replace(/_/g, " "));
    } else {
      return this.titleCase(str);
    }
  },
  titleCase(str: any) {
    if (str && typeof str === "string") {
      return str
        .toLowerCase()
        .split(" ")
        .map((word: any) => {
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(" ");
    } else {
      return "";
    }
  },
  isNumber(str: string) {
    if (/^\d+$/.test(str)) {
      return true;
    }
    return false;
  },
  handlePercentageInput(e: React.KeyboardEvent<HTMLInputElement>) {
    const { value } = e.currentTarget;
    // Allow control keys (Backspace, Arrow keys, Delete, etc.)
    if (
      e.ctrlKey ||
      e.metaKey ||
      ["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"].includes(e.key)
    ) {
      return;
    }

    // Allow only numbers, '.' and '%'
    if (!/[\d.]/.test(e.key)) {
      e.preventDefault();
      return;
    }

    // Prevent multiple '.'
    if (e.key === "." && value.includes(".")) {
      e.preventDefault();
      return;
    }

    // Ensure only two digits after the decimal point
    const decimalIndex = value.indexOf(".");
    if (decimalIndex !== -1 && e.key !== "%" && /\d/.test(e.key)) {
      const decimalPart = value.slice(decimalIndex + 1);
      if (decimalPart.length >= 2) {
        e.preventDefault();
      }
    }
  },
  async storeAccessToken(access_token: string) {
    await localStorage.setItem("access_token", access_token);
  },
  removeDialCode(phone: string, dialCode: string): string {
    if (!phone) return "";
    let s = String(phone).trim();
    if (!dialCode) return s.replace(/[^\d]/g, "");

    const cleanDial = String(dialCode).replace(/[^\d]/g, "");
    if (s.startsWith("+")) {
      const withoutPlus = s.slice(1).trim();
      if (cleanDial && withoutPlus.startsWith(cleanDial)) {
        s = withoutPlus.slice(cleanDial.length).trim();
      }
    } else if (cleanDial && s.startsWith(cleanDial) && s.length > cleanDial.length + 8) {
      s = s.slice(cleanDial.length).trim();
    }
    return s.replace(/[^\d]/g, "");
  },
};

export default HelperService;
